export default function getAlertTitle(str) {
  return str?.charAt(0).toUpperCase() + str?.slice(1);
}
